// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../images/icons/form-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg fill=%27gray%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../images/icons/star-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* common - start */
a.disabled-link {
  pointer-events: none;
  opacity: 0.5;
}
section h1,
.section-title h1,
.section-title h2 {
  font-family: "AvertaSemiBold", sans-serif;
  font-size: 20px;
  color: var(--colorYellow);
}
section.full-ht {
  min-height: calc(100vh - 180px);
}
section.bg {
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  padding: 50px;
}
section.bg .section-title h3 {
  font-family: "SegoePro-Bold", sans-serif;
  font-size: 40px;
  text-transform: capitalize;
  color: #f4f3f2;
}
section.bg .section-title p {
  font-size: 18px;
}
section.bg .section-title + .bottom-text {
  margin-top: 0;
  color: var(--colorYellow);
  height: 0;
  opacity: 0;
  transition: height 1s, margin-top 1s, opacity 0s;
}
section.bg:hover .section-title + .bottom-text {
  margin-top: 35vh;
  height: auto;
  opacity: 1;
  transition: height 1s, margin-top 1s, opacity 1s;
}
section.bg .section-title + .bottom-text p {
  font-size: 22px;
}

button.back {
  color: var(--colorYellow);
}
.breadcrumbs {
  margin-top: -20px;
}
.breadcrumbs ul {
  padding-left: 0;
}
.breadcrumbs ul li,
.breadcrumbs ul li a {
  display: inline-block;
  vertical-align: middle;
  color: var(--colorYellow);
  font-size: 12px;
}
.breadcrumbs ul li:not(:last-child) {
  margin-right: 5px;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #f2f2f2 !important;
}
::placeholder {
  color: #999999 !important;
}

table tbody tr.disabled {
  pointer-events: none;
  opacity: 0.5;
}

@media (min-width: 576px) {
  .modal-medium .modal-dialog {
    max-width: 700px;
  }
}

.long-desc {
  max-height: 80px;
  position: relative;
  overflow-y: auto;
}
/* common - end */

/* ======= Home SaaS - start ======= */
.home-saas .inner {
  background-color: #191e27;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.home-saas .inner h4 {
  color: #979a9f;
  font-family: "SegoePro-SemiBold", sans-serif;
  font-size: 14px;
  margin-bottom: 20px;
}
.home-saas .inner .image {
  margin-top: auto;
  display: block;
  text-align: center;
}

.saas-manage {
  padding: 30px;
  background-color: #191e27;
  margin-top: 25px;
}
.saas-manage > .row {
  align-items: center;
}
.saas-manage > .row > div {
  text-align: center;
  position: relative;
}
.saas-manage span {
  display: block;
}
.saas-manage span.text {
  color: var(--colorYellow);
  margin-top: 10px;
}
.saas-manage .create {
  position: relative;
  display: inline-block;
}
.saas-manage .create button {
  min-height: 90px;
  height: 100%;
  padding: 10px 35px;
  background-color: #0c1017;
}
.saas-manage .popup-list {
  display: none;
  padding: 15px 20px;
  background-color: #0c1017;
  width: max-content;
  position: absolute;
  z-index: 1;
  left: 50%;
}
.saas-manage .popup-list.show {
  display: block;
}
.saas-manage .popup-list ul {
  list-style: none outside;
  padding-left: 0;
  margin-bottom: 0;
  text-align: left;
}
.saas-manage .popup-list ul li a {
  color: #979a9f;
  position: relative;
}
.saas-manage .popup-list ul li a.in-progress:before,
.saas-manage .popup-list ul li a.completed:before {
  content: "";
  position: absolute;
  left: -10px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
}
.saas-manage .popup-list ul li a.in-progress:before {
  background-color: var(--colorYellow);
}
.saas-manage .popup-list ul li a.completed:before {
  background-color: #08d155;
}
.saas-manage .popup-list ul li:not(:last-child) {
  margin-bottom: 5px;
}
.saas-manage .create .popup-list {
  left: auto;
  right: calc(-100% - 20px);
  top: 0;
}

.list-table {
  position: relative;
  margin-top: 25px;
}
.list-table h4 {
  font-size: 16px;
  color: var(--colorYellow);
  padding-left: 30px;
  position: absolute;
  left: 0;
  top: 17px;
}
.list-table div[data-test="datatable-entries"] .bs-select {
  display: none;
}
.list-table div[data-test="datatable-search"] .form-control {
  background-color: #191e27;
  border: none;
  padding: 10px 30px;
  border-radius: 0;
  width: 300px;
  margin-bottom: 10px !important;
}
.list-table div[data-test="datatable-search"]:before {
  content: "Search";
  color: var(--colorYellow);
  margin-right: 10px;
}
table.table-striped {
  background-color: #191e27;
}
.table.table-striped > :not(caption) > * > *,
.table.table-bordered > :not(caption) > * > *,
.table > :not(caption) > * > * {
  background-color: transparent;
  color: #999999;
}
table.table-striped > tbody > tr > *,
table.table-striped > tbody > tr:nth-of-type(odd) > * {
  color: #85898e;
}
table.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #252a31;
}
table.table-striped > tbody > tr > td {
  padding-left: 30px;
  padding-right: 30px;
  height: 29px;
}
table.table-striped > tbody > tr > td a {
  color: inherit;
}
table.table-striped > tbody > tr > td span.new {
  background-color: var(--colorYellow);
  font-family: "SegoePro-SemiBold", sans-serif;
  font-size: 0.6em;
  color: #3d4045;
  padding: 0 3px;
  border-radius: 5px;
  margin-left: 10px;
}
table.table-striped > thead[data-test="datatable-head"] th {
  color: var(--colorYellow);
  font-weight: normal;
  padding: 10px 30px;
}
table.table-striped > thead[data-test="table-foot"] {
  display: none;
}
.list-table .dataTables_info {
  display: none;
}
.list-table div[data-test="datatable-pagination"] {
  width: auto;
  margin-left: auto;
}
.list-table .pagination .page-item .page-link {
  min-width: 36px;
  text-align: center;
  cursor: pointer;
}
.list-table .pagination .page-item.disabled .page-link {
  cursor: auto;
}
.list-table .pagination .page-item .page-link,
.list-table .pagination .page-item:last-child .page-link,
.list-table .pagination .page-item.disabled .page-link {
  background-color: transparent;
  border: none;
  border-top: 0.25px solid #616369;
  border-bottom: 0.25px solid #616369;
  border-radius: 0;
  color: #616369;
}
.list-table .pagination .page-item:first-child .page-link,
.list-table .pagination .page-item:last-child .page-link {
  border: 0.25px solid #616369;
}
.list-table .pagination .page-item:first-child .page-link:before {
  content: "\\2039";
  font-size: 30px;
  line-height: 15px;
  display: inline-block;
  vertical-align: top;
}
.list-table .pagination .page-item:first-child .page-link span,
.list-table .pagination .page-item:last-child .page-link span,
.list-table .pagination .page-item .page-link span.sr-only {
  display: none;
}
.list-table .pagination .page-item:last-child .page-link:before {
  content: "\\203A";
  font-size: 30px;
  line-height: 15px;
  display: inline-block;
  vertical-align: top;
}
.list-table .pagination .page-item.active .page-link {
  color: #85898e;
}

table.table-bordered,
table.table-bordered > :not(:first-child) {
  border-color: #3d4045;
  border-width: 1px;
  color: var(--colorGray);
}
table.table-bordered thead th {
  color: var(--colorYellow);
  font-weight: normal;
}
table.table-bordered tbody td {
  vertical-align: middle;
}
/* ======= Home SaaS - end ======= */

/* ======= Forms - start ======= */
section.form {
  padding: 35px 40px;
  background: #191e27 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right
    bottom -70px;
}
.formitem {
  position: relative;
}
.formitem .form-label {
  position: absolute;
  transition-duration: 1s;
}
input[type="text"],
input[type="text"]:focus,
input[type="email"],
input[type="email"]:focus,
input[type="password"],
input[type="password"]:focus {
  border-width: 0 0 1px 0;
  color: #f2f2f2;
  border-color: #3d4045;
  background: none;
}
label {
  min-width: 70px;
}
label + input[type="text"],
label + input[type="text"]:focus,
label + input[type="email"],
label + input[type="email"]:focus,
label + input[type="password"],
label + input[type="password"]:focus {
  border-width: 1px;
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 75px);
  max-width: 250px;
}
input[type="text"]:read-only,
input[type="email"]:read-only,
input[type="password"]:read-only {
  opacity: 0.25;
}
select.form-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 5px;
  border: none;
  border-bottom: 1px solid #3d4045;
  border-radius: 0;
  color: #979a9f;
}
select.form-select.border {
  border-color: #3d4045 !important;
}
select.form-select option {
  background-color: #0c1017;
}
form h4 {
  font-size: 0.9rem;
  color: var(--colorYellow);
}
form h4 + .repeat-address {
  margin-left: 20px;
}
form h4 + .repeat-address label {
  font-size: 13px;
}
form h5 {
  font-size: 1rem;
  color: var(--colorYellow);
}
form h6 {
  font-size: 1em;
  color: var(--colorYellow);
}
form fieldset {
  border: 1px solid #3d4045;
  padding: 20px 30px;
}
form fieldset.heading {
  padding: 0 30px;
  background-color: #161b22;
}
form fieldset.heading .fieldset-heading > h6,
form fieldset.heading .fieldset-heading ~ div > h6 {
  padding: 15px 0 10px;
}
form fieldset.heading .fieldset-heading ~ div > div {
  padding: 10px 0;
}
form fieldset.heading .fieldset-heading ~ div > div h6 {
  margin-top: 5px;
}
form fieldset .fieldset-heading,
form fieldset .fieldset-heading ~ div:not(:last-child) {
  position: relative;
  border-right: 1px solid #3d4045; /* min-width: fit-content; */
}
form fieldset .row.bdr-btm:not(:last-child) {
  border-bottom: 1px solid #3d4045;
}
form fieldset .fieldset-heading > div,
form fieldset .fieldset-heading ~ div:not(:last-child) > div {
  position: relative;
  z-index: 1;
}
form fieldset .fieldset-heading h5 {
  width: 90%;
  display: inline-flex;
  align-items: center;
  height: 100%;
  position: relative;
  z-index: 1;
}
form fieldset .fieldset-heading h5 label {
  line-height: 1em;
  vertical-align: middle;
}
form fieldset .fieldset-heading ~ div:not(:last-child) > div {
  /* width: 90%; */
  position: relative;
  z-index: 1;
}
/* form fieldset .fieldset-heading:after, form fieldset .fieldset-heading ~ div:not(:last-child):after { content: ""; position: absolute; left: 0; top: 0; width: 90%; height: 100%; border-right: 1px solid #3D4045; z-index: 0;} */
.form-check-input[type="checkbox"],
.form-check-input[type="radio"] {
  background-color: transparent;
  border-color: #979a9f;
}
form .form-select,
form .form-control,
form .form-select:focus,
form .form-control:focus {
  font-size: 14px;
  background-color: transparent;
  color: #ffffff;
}
form .form-select:focus-visible,
form .form-control:focus-visible {
  outline: none;
}
form fieldset:disabled,
button:disabled {
  opacity: 0.6;
}
form .form-select:disabled {
  background-color: transparent;
}
form .message {
  color: #ff0000;
}
.form-check-inline .form-check-label {
  min-width: auto;
}

.roles-wrap,
.profile-wrap {
  display: inline-block;
  width: calc(100% - 75px);
  max-width: 250px;
  vertical-align: top;
  margin-left: 5px;
}
.profile-wrap {
  position: relative;
}
.profile-wrap input[type="text"] {
  border-width: 1px;
  padding-right: 30px;
}
.profile-wrap button.btn-transparent {
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 3px;
  width: 23px;
  height: 23px;
  padding: 0;
  line-height: 21px;
}
.profile-wrap.full-width {
  width: 100%;
  max-width: none;
  margin-left: 0;
}
.profile-wrap.full-width input[type="text"] {
  border-width: 0 0 1px 0;
}
.roles-wrap select {
  border: 1px solid #3d4045;
  border-radius: 6px;
}

section.form.no-bg-img {
  background-image: none;
}

ul.machine-list {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none outside;
}
ul.machine-list li {
  display: inline-block;
  margin-right: 20px;
  border: 1px solid var(--colorYellow);
  border-radius: 5px;
  font-size: 12px;
  padding: 3px 10px;
  min-width: 120px;
  display: inline-flex;
  justify-content: space-between;
}
ul.machine-list li button.btn-close {
  background-size: 10px auto;
}

.modules-preview h2 {
  font-family: "AvertaSemiBold", sans-serif;
  font-size: 20px;
  color: var(--colorYellow);
}
ul.tick {
  list-style: none outside;
  padding-left: 0;
}
ul.tick > li {
  color: var(--colorYellow);
}
ul.tick > li > div.tick-icon {
  display: flex;
  align-items: center;
}
ul.tick > li > div.tick-icon:before {
  content: "\\2713";
  color: var(--colorOrange);
  margin-right: 10px;
}
ul.tick > li > ul {
  list-style: none outside;
  padding-left: 0;
  font-size: 12px;
  color: var(--colorGray);
  margin-top: 20px;
}
ul.tick.row li.border-end:last-child {
  border-right: none !important;
}
/* ======= Forms - end ======= */

/* ======= View Client - start ======= */
.client-status {
  background-color: #191e27;
  padding: 30px 40px;
  margin-top: 25px;
}
.client-status h2 {
  font-size: 14px;
  color: var(--colorYellow);
  margin-bottom: 20px;
}
.progressbar {
  list-style: none outside;
  margin-bottom: 0;
  padding-left: 0;
  display: flex;
}
.progressbar li {
  position: relative;
  text-align: center;
  width: 20%;
}
.progressbar li:before {
  content: "";
  width: 20px;
  height: 20px;
  background-color: #3d4045;
  margin: 0 auto 10px auto;
  outline: 1px solid #3d4045;
  outline-offset: 3px;
  display: block;
  border-radius: 50%;
  text-align: center;
}
.progressbar li.completed:before {
  content: "\\2713 ";
  color: var(--colorYellow);
  outline-color: var(--colorYellow);
}
.progressbar li:after {
  content: "";
  position: absolute;
  width: calc(100% - 30px);
  height: 1px;
  border-top: 1px dashed #3d4045;
  top: 10px;
  left: calc(-50% + 16px);
  z-index: 0;
}
.progressbar li:first-child:after {
  content: none;
}
.progressbar li,
.progressbar li a {
  color: var(--colorGray);
}

.client-subscription {
  background-color: #191e27;
  padding: 25px 40px;
  margin-top: 25px;
  margin-bottom: 25px;
  color: #979a9f;
}
.client-subscription h2 {
  font-size: 14px;
  color: var(--colorYellow);
  margin-bottom: 20px;
}
.client-subscription .client-infrastructure {
  background-color: #0c0f14;
  padding: 15px 40px;
  text-align: center;
}
.client-subscription .client-infrastructure span {
  display: block;
}
.client-subscription .client-infrastructure span.text {
  line-height: 1;
  margin-top: 5px;
}
.client-subscription .subscription {
  list-style: none outside;
  margin-bottom: 0;
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-align: center;
}
.client-subscription .subscription li {
  padding: 10px 15px;
  border: 1px solid #3d4045;
  margin: 5px 7px; /* width: 150px; */
  position: relative;
}
.client-subscription.saas-subscription .subscription li {
  width: 150px;
}
.client-subscription .subscription li span {
  display: block;
}
.client-subscription .subscription li span.image {
  min-height: 40px;
}
.client-subscription .subscription li span.text {
  margin-top: 5px;
  font-size: 13px;
}
.client-subscription .subscription li > button.subscribe {
  display: none;
  position: absolute;
  top: 10px;
  color: white;
  font-size: 10px;
  width: 55px;
  left: 50%;
  margin-left: -27px;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 5px;
}
.client-subscription .subscription li:hover > button.subscribe {
  display: block;
}
.client-subscription .subscription li.subscribed:before {
  content: "\\2713 ";
  font-size: 12px;
  font-weight: bold;
  line-height: 15px;
  position: absolute;
  right: -7px;
  top: -7px;
  color: #3d4045;
  width: 15px;
  height: 15px;
  background-color: var(--colorYellow);
  display: block;
  border-radius: 50%;
  text-align: center;
}
.client-subscription .subscription li.subscribed span.image img {
  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)
    hue-rotate(347deg) brightness(96%) contrast(107%);
}
.client-subscription .subscription li.subscribed span.text {
  color: var(--colorYellow);
}

.client-subscription .react-multi-carousel-list.subscription li {
  border: none;
  text-align: center;
  margin: 0;
}
.client-subscription .react-multi-carousel-list.subscription li > div {
  width: 100%;
  border: 1px solid #3d4045;
  display: inline-block;
}

.label-wrap > label {
  position: relative;
  display: block;
  padding: 10px;
  text-align: center;
}
/* Match .reports-list .item > div's box so function chips are the same
   size as product cards, whether or not that function has a matching icon.
   react-multi-carousel wraps every item in its own <li>, so the legacy
   ".subscription li > div" border rule below still matches this div even
   though it was written for the old markup -- override it back to none,
   same as product cards (.reports-list has no such border at all). */

.label-wrap span.image {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 85px !important;
  min-height: 85px !important;
  max-width: 100%;
  margin-bottom: 10px;
  background-color: #191e27;
}
.label-wrap span.image img {
  width: 50px !important;
  height: 50px !important;
  object-fit: contain;  margin: 0 auto;
}
.label-wrap input[type="radio"] {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}
/* .label-wrap input[type="radio"]:checked + span.image img {filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%) hue-rotate(347deg) brightness(96%) contrast(107%);} */
.label-wrap input[type="radio"]:checked + span.image + span.text {
  color: var(--colorYellow);
}

.react-multiple-carousel__arrow--left {
  left: 0;
}
.react-multiple-carousel__arrow--right {
  right: 0;
}
/* ======= View Client - end ======= */

/* ======= Client Interface - start ======= */
/* ======= Home SaaS - start ======= */
.workbasket {
  background-color: #191e27;
  padding: 20px 40px;
  margin-top: 25px;
}
.workbasket h2 {
  font-size: 14px;
  color: var(--colorGray);
  margin-bottom: 20px;
}
.workbasket ul {
  list-style: none outside;
  margin-bottom: 0;
  padding-left: 0;
  display: flex;
}
.workbasket ul li:not(:last-child) {
  margin-right: 20px;
}
.workbasket ul li a {
  color: var(--colorYellow);
  text-decoration: underline;
}
/* ======= Home SaaS - end ======= */
/* ======= Client Interface - end ======= */

/* ======= Map meta data - start ======= */
fieldset.starred {
  position: relative;
  overflow: hidden;
}
fieldset.starred:before {
  position: absolute;
  display: block;
  content: "";
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 40px solid #3d4045;
  border-right: 40px solid transparent;
}
fieldset.starred:after {
  position: absolute;
  display: block;
  content: "";
  top: 4px;
  left: 4px;
  width: 16px;
  height: 16px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  min-width: auto;
  height: 20px;
  margin: 0 10px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2c2d2f;
  border: 1px solid var(--colorGray);
  border-radius: 20px;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 1px;
  bottom: 1px;
  background-color: var(--colorGray);
  border-radius: 50%;
  transition: 0.4s;
}
input:checked + .slider {
  border: 1px solid var(--colorYellow);
}
input:checked + .slider:before {
  transform: translateX(20px);
  background-color: var(--colorYellow);
}
td .switch {
  width: 30px;
  height: 15px;
}
td .slider:before {
  width: 11px;
  height: 11px;
}
td input:checked + .slider:before {
  transform: translateX(15px);
}
td input:disabled + .slider {
  opacity: 0.5;
}
/* ======= Map meta data - end ======= */

/* ======= Deploy BI - start ======= */
.deploy-bi .col-wrap {
  background-color: #0f1622;
  padding: 10px 15px;
  display: flex;
  border-radius: 10px;
  height: 100%;
}
.deploy-bi .col-wrap.cursor-pointer {
  cursor: pointer;
}
.deploy-bi .icon {
  min-width: 90px;
  height: 90px;
  background-color: #191e27;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}
.deploy-bi .icon img {
  max-width: 50px;
}
.deploy-bi .content-wrap {
  /* margin-top: 20px; */
  color: var(--colorYellow);
}
.deploy-bi .content-wrap h6 {
  font-family: "SegoePro-SemiBold", sans-serif;
}
.deploy-bi .content-wrap span,
.deploy-bi .content-wrap .info {
  font-size: 12px;
  vertical-align: middle;
  display: inline-block;
}
.deploy-bi .content-wrap .info {
  border: 1px solid var(--colorYellow);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  font-size: 10px;
  margin-left: 7px;
  color: var(--colorYellow);
}
.deploy-bi .button-wrap {
  min-width: 100px;
}
.ribbon {
  display: inline-block;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 8px), 0 100%);
  background-color: var(--colorYellow);
  width: 20px;
  height: 48px;
  margin-top: -10px;
  position: relative;
}
.Subscribe > div.cursor-pointer {
  cursor: pointer;
}
.Subscribe .status {
  opacity: 0.53;
}
.Subscribe .ribbon {
  opacity: 0.37;
}
.Subscribe .ribbon:before {
  background-color: #0f1622;
  position: absolute;
  display: block;
  content: "";
  width: 18px;
  height: 46px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 8px), 0 100%);
  left: 1px;
  top: 0;
}
.Subscribe .button-wrap button.btn-yellow {
  background-color: transparent;
  color: var(--colorYellow);
}
.Unavailable img,
.Unavailable h6,
.Unavailable .status {
  opacity: 0.34;
}
.Unavailable .status {
  color: #ffffff;
}
.Unavailable .status .info {
  border-color: #ffffff;
}
.Unavailable .ribbon {
  background-color: #2c2c2c;
  opacity: 0.4;
}
.button-wrap {
  margin-left: auto;
  text-align: center;
}
.button-wrap button.btn-yellow {
  padding: 0 5px;
  border-radius: 5px;
  margin-top: 20px;
}

.modal-deploy-bi .modal-dialog {
  max-width: 840px;
}
.modal-deploy-bi .modal-content {
  background-color: #0c1017;
}
.modal-deploy-bi .modal-header {
  border-bottom: 1px solid #212121;
  align-items: flex-start;
}
.modal-deploy-bi .modal-header > div {
  text-align: center;
  flex: 1 1;
}
.modal-deploy-bi .modal-footer {
  border-top: 1px solid #212121;
  justify-content: flex-end;
}
.modal-deploy-bi button.btn-close {
  width: 5px;
  height: 5px;
  top: -15px;
  right: -15px;
}
.modal-deploy-bi .col-wrap {
  background-color: transparent;
  padding: 0;
  text-align: left;
}
.modal-deploy-bi .button-wrap {
  margin-left: 30px;
  min-width: auto;
}
.modal-deploy-bi .ribbon {
  margin-top: 15px;
}
.modal-deploy-bi .steps {
  list-style: none outside;
  padding: 0;
  display: inline-flex;
  justify-content: center;
  position: relative;
  color: var(--colorYellow);
  margin-left: auto;
  margin-right: auto;
}
.modal-deploy-bi .steps:before {
  display: block;
  content: "";
  height: 1px;
  width: 75%;
  background-color: #212121;
  position: absolute;
  top: 7px;
}
.modal-deploy-bi .steps li {
  padding: 0 30px;
  text-align: center;
}
.modal-deploy-bi .steps li span {
  width: 15px;
  height: 15px;
  display: inline-block;
  border: 1px solid var(--colorYellow);
  border-radius: 50%;
  position: relative;
  background-color: #0c1017;
}
.modal-deploy-bi .steps li.completed span:after {
  width: 7px;
  height: 7px;
  display: block;
  content: "";
  background-color: var(--colorYellow);
  border-radius: 50%;
  position: absolute;
  left: 3px;
  top: 3px;
}
.modal-deploy-bi .table {
  color: #f4f3f2;
  font-size: 12px;
}
.modal-deploy-bi .border-bottom {
  border-color: #212121 !important;
}

.modal.terms-policies .modal-body {
  max-height: 50vh;
  overflow-y: auto;
}
.modal.terms-policies .modal-body h4 {
  color: inherit;
  font-family: "SegoePro-Bold", sans-serif;
  font-size: inherit;
}
.modal .modal-body a {
  color: inherit;
}
.modal-footer button,
.modal-footer button:active,
.modal-footer button:focus {
  background-color: #fd9f29;
  color: #0c1017;
  font-weight: bold;
  padding-left: 20px;
  padding-right: 20px;
}
.modal-footer button:active:hover,
.modal-footer button:hover {
  background-color: #fd9f29;
  color: #0c1017;
  opacity: 0.8;
}
/* ======= Deploy BI - end ======= */

/* ======= Users - start ======= */
.toggle-password {
  position: absolute;
  right: 0;
  top: 10px;
  cursor: pointer;
}
.datatable.datatable-users tbody[data-test="table-body"] td div {
  display: flex;
  align-items: flex-start;
}
.datatable.datatable-users tbody[data-test="table-body"] td div ul {
  list-style: disc inside;
}
.datatable.datatable-users tbody[data-test="table-body"] td div ul li {
  margin-bottom: 0;
}
.datatable.datatable-users
  tbody[data-test="table-body"]
  td
  div
  ul
  li:last-child {
  margin-bottom: 0;
}
.datatable.datatable-users .fas,
.datatable.datatable-users .far {
  color: #85898e;
}
/* ======= Users - end ======= */

/* ======= Dashboard - start ======= */
section.iframe-wrapper {
  height: 60vh;
}
section.iframe-wrapper > iframe {
  height: 100%;
  width: 100%;
}
section.bg-dark-gray {
  background-color: #191e27;
  margin-top: 25px;
  padding: 40px;
  margin-bottom: 25px;
  color: var(--colorYellow);
}
.reports-list {
  /* flex-wrap: nowrap; overflow-x: auto; padding-top: 25px; padding-bottom: 25px;*/
  text-align: center;
}
.reports-list li {
  padding: 10px 15px;
}
.reports-list .unavailable .item {
  opacity: 0.6;
}
.reports-list .item {
  display: inline-block;
  cursor: pointer;
  position: relative;
  width: 100%;
}
.reports-list .item.disabled {
  pointer-events: none;
}
.reports-list .item > img {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 20px;
  display: none;
}
.reports-list .item:hover > img,
.reports-list .item.active > img,
.reports-list .item.disabled > img {
  display: block;
}
.reports-list .item > div {
  margin-bottom: 10px;
  height: 85px;
  max-width: 100%;
  background-color: #121212;
  line-height: 85px;
}
.reports-list .item span {
  display: block;
}
.reports-list .item > button {
  display: none;
  position: absolute;
  top: 28px;
  color: white;
  font-size: 10px;
  width: 55px;
  left: 50%;
  margin-left: -27px;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 5px;
}
.reports-list .item > button.txt-yellow {
  color: var(--colorYellow);
}
.reports-list .item > button.txt-gray {
  color: var(--colorGray);
}
.reports-list .item:hover > button {
  display: block;
}
.content-wrap {
  flex-wrap: nowrap;
}
.content-wrap main {
  flex: 1 1;
  min-width: 0;
}
.content-wrap aside {
  width: var(--rightNavWidth);
  max-width: var(--rightNavWidth);
  flex-shrink: 0;
  height: auto;
  overflow: visible;
  padding-right: 0;
  box-sizing: border-box;
}

/* rightnav variable and collapsed support */
:root {
  --rightNavWidth: 28%;
  --sidebarTopOffset: 138px; /* pages can override this to account for header/steps heights */
}
body.rightnav-collapsed {
  --rightNavWidth: 0px;
}
/* when collapsed reduce inner content visibility */
.right-aside {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1001;
  transition: width 0.2s ease, height 0.2s ease, background-color 0.2s ease;
  overflow: hidden;
  width: var(--rightNavWidth);
  max-width: var(--rightNavWidth);
  height: 100vh !important;
  background-color: var(--color2);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.3);
}
.right-aside-inner {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-x: hidden !important;
  position: relative;
}
.right-aside-inner iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
}

/* collapsed state: only show the toggle button */
body.rightnav-collapsed .right-aside .right-aside-inner {
  display: none;
}
body.rightnav-collapsed .right-aside {
  width: 0 !important;
  max-width: 0 !important;
  border-left: none !important;
  box-shadow: none !important;
  overflow: hidden !important;
}

#chat-body {
  height: calc(100% - 120px);
  margin-bottom: 20px;
  overflow-y: auto;
  background-color: #191e27;
  border-radius: 5px;
}
#chat-body .chat-list {
  list-style: none outside;
  padding-left: 0;
}
.chat-list .msg-wrapper > div {
  display: flex;
  padding: 10px;
  align-items: center;
}
.chat-list .msg-wrapper.bot-msg > div {
  background-color: var(--colorYellow);
  color: #000000;
}
.chat-list li.msg-wrapper > div .text {
  margin-left: 10px;
  flex: 1 1;
  white-space: pre-line;
}
#form-chat .form-wrapper {
  position: relative;
}
#form-chat .form-wrapper textarea {
  border-color: #3d4045;
  padding-right: 35px;
}
#form-chat .form-wrapper button[type="submit"] {
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 0;
  border: 0;
}
/* ======= Dashboard - end ======= */

/* ======= Loan Underwrite - start ======= */
/* variables - start */
:root {
  --color1: #0c1017;
  --color2: #191e27;
  --color3: #979a9f;
  --color4: #323232;
}
/* variables - end */

.dark-bg {
  background-color: var(--color2);
}
.alert-msg {
  position: fixed;
  top: 0;
  left: 0;
  background-color: var(--colorYellow);
  color: var(--color1);
  text-align: center;
  width: 100%;
  padding: 10px 20px;
  z-index: 9999;
}

/* buttons - start */
.loan-underwrite button.btn,
.loan-underwrite button.btn:hover,
.loan-underwrite button.btn:focus,
.loan-underwrite button.btn:first-child:active {
  border-radius: 0;
  font-family: "SegoePro-Bold", sans-serif;
  font-size: 15px;
  padding: 10px 25px;
}
.loan-underwrite button.btn-primary,
.loan-underwrite button.btn-primary:hover,
.loan-underwrite button.btn-primary:focus,
.loan-underwrite button.btn-primary:first-child:active,
.loan-underwrite button.btn-primary:disabled {
  border: 1px solid var(--colorYellow);
  background-color: var(--colorYellow);
  color: var(--color1);
}
.loan-underwrite button.btn-transparent,
.loan-underwrite button.btn-transparent:hover,
.loan-underwrite button.btn-transparent:focus,
.loan-underwrite button.btn-transparent:first-child:active {
  border-color: var(--colorYellow);
  background-color: #000000;
  color: #fd9f29;
}
.loan-underwrite button.btn-plain,
.loan-underwrite button.btn-plain:hover,
.loan-underwrite button.btn-plain:focus,
.loan-underwrite button.btn-plain:first-child:active {
  border: none;
}
.loan-underwrite button.btn-plain {
  color: #ffffff;
}
.loan-underwrite button.btn-plain:hover {
  color: var(--colorYellow);
}

.loan-underwrite .btn-dotted-bg {
  position: relative;
}
.loan-underwrite .btn-dotted-bg:before {
  content: "";
  display: block;
  width: 80%;
  left: 50%;
  top: 50%;
  border-top: 1px dashed var(--colorYellow);
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: -1;
}
/* buttons - end */

/* form - start */
.loan-underwrite .form-label,
.loan-underwrite label {
  color: var(--colorYellow);
}
.loan-underwrite .form-control,
.loan-underwrite .form-control:focus,
.loan-underwrite .form-select,
.loan-underwrite .form-select:focus {
  background-color: var(--color2);
  border-color: var(--color2);
  border-radius: 0;
  color: var(--colorWhite);
  width: 100%;
  max-width: 100%;
  display: block;
}
.loan-underwrite .form-check-input,
.loan-underwrite .form-check-input:focus {
  background-color: var(--color2);
  /* border-color: var(--color2); */
  color: var(--colorWhite);
  display: block;
  /* margin-bottom: 0.5rem; */
}
.loan-underwrite .form-control[type="number"]::-webkit-inner-spin-button,
.loan-underwrite input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
.loan-underwrite .form-control[type="number"] {
  -moz-appearance: textfield;
}
.loan-underwrite .input-group-text {
  background-color: var(--colorYellow);
  color: var(--colorWhite);
  border-color: var(--colorYellow);
  border-radius: 0;
  width: 50px;
  font-size: 14px;
}
.loan-underwrite .input-group-text.read-only {
  opacity: 0.25;
}
.loan-underwrite .bi {
  position: relative;
  bottom: 10px;
  font-size: 10px;
}
.loan-calculate .switch {
  width: 30px;
  height: 15px;
  margin-bottom: 0.5rem;
}
.loan-calculate .slider:before {
  width: 11px;
  height: 11px;
}
.loan-calculate input:checked + .slider:before {
  transform: translateX(15px);
}
.loan-calculate input:disabled + .slider {
  opacity: 0.5;
}
.loan-calculate input:disabled {
  opacity: 0.25;
}
.loan-calculate select:disabled {
  opacity: 0.25;
}
.loan-calculate .col-sm-4 {
  flex: 0 0 auto !important;
  width: 33.333333% !important;
}
/* .loan-underwrite .divider {
  display: flex;
  align-items: center;
} */
.loan-underwrite .divider:before,
.divider:after {
  content: none;
}

#decision .row {
  flex-wrap: nowrap;
}

#decision .col-sm-4 {
  flex: 0 0 auto !important;
  width: 33.333333% !important;
}

.loan-underwrite-header .steps {
  list-style: none outside;
  padding: 0;
  display: flex;
  justify-content: space-around;
  position: relative;
  color: var(--colorYellow);
  margin-left: auto;
  margin-right: auto;
}
.loan-underwrite-header .steps:before {
  display: block;
  content: "";
  height: 1px;
  width: 79%;
  background-color: #212121;
  position: absolute;
  top: 7px;
  left: 10%;
}
.loan-underwrite-header .steps li {
  padding: 0 30px;
  text-align: center;
}
.loan-underwrite-header .steps li span {
  width: 15px;
  height: 15px;
  display: inline-block;
  border: 1px solid var(--colorYellow);
  border-radius: 50%;
  position: relative;
  background-color: #0c1017;
}
.loan-underwrite-header .steps li.completed span:after {
  width: 7px;
  height: 7px;
  display: block;
  content: "";
  background-color: var(--colorYellow);
  border-radius: 50%;
  position: absolute;
  left: 3px;
  top: 3px;
}

.loan-underwrite .table th {
  color: var(--color3);
}
.loan-underwrite .table thead th {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: right;
}
.loan-underwrite .table tbody td {
  color: var(--colorYellow);
  padding-top: 20px;
  padding-bottom: 20px;
}

.loan-underwrite .underwrite-loan .icon {
  height: 55px;
}
/* form - end */

@media (min-width: 640px) {
  .loan-underwrite .container-wrapper {
    padding-left: 50px;
    padding-right: 50px;
  }
  .loan-underwrite-header .steps ul {
    flex-direction: row;
    justify-content: space-around;
  }
  .loan-underwrite-header .steps ul li {
    flex-direction: column;
  }
  .loan-underwrite-header .steps ul li > span {
    margin-top: 5px;
  }
  .loan-underwrite-header .steps ul li.completed > span:before {
    content: "\\2713";
    color: var(--colorGreen);
    line-height: 12px;
    border: 1px solid var(--colorGreen);
    border-radius: 3px;
    display: inline-block;
    margin-right: 7px;
    font-size: 9px;
    width: 13px;
    height: 13px;
    text-align: center;
    vertical-align: middle;
  }
  .loan-underwrite-header .steps ul:before {
    border-top: 1px dashed var(--color3);
    width: 35%;
    top: 35px;
    right: 50%;
  }
  .loan-underwrite-header .steps ul:after {
    border-top: 1px dashed var(--color3);
    width: 35%;
    top: 35px;
    left: 50%;
  }

  .loan-underwrite .table thead {
    background-color: var(--color2);
    border-top: 1px solid var(--color4);
  }
  .loan-underwrite .table thead th {
    border-bottom: none;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;
    vertical-align: top;
  }
  .loan-underwrite .table tbody td {
    border-bottom: 1px solid var(--color4);
    text-align: center;
  }
}
/* ======= Loan Underwrite - end ======= */
`, "",{"version":3,"sources":["webpack://./src/assets/css/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;;;EAGE,yCAAyC;EACzC,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,gDAAgD;AAClD;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gDAAgD;AAClD;AACA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;;;;EAIE,yDAAiD;EAAjD,iDAAiD;EACjD,2CAA2C;AAC7C;AAUA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,iBAAiB;;AAEjB,sCAAsC;AACtC;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;;;EAGE,6BAA6B;EAC7B,YAAY;EACZ,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA,oCAAoC;;AAEpC,kCAAkC;AAClC;EACE,kBAAkB;EAClB;gBACc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;;;;;EAME,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;;;;;EAME,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yDAAqN;EACrN,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAIlB,+BAA+B,EAAE,4BAA4B;AAH/D;AAKA;EACE,gCAAgC;AAClC;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA,oOAAoO;AACpO;;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;;;EAIE,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA,gCAAgC;;AAEhC,wCAAwC;AACxC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe,EAAE,kBAAkB;EACnC,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE;qDACmD;AACrD;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;AACA;;;;;qEAKqE;;AAErE;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,GAAG,cAAc;AACtC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,UAAU;EACV,eAAe;AACjB;AACA,6LAA6L;AAC7L;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;AACA;EACE,QAAQ;AACV;AACA,sCAAsC;;AAEtC,6CAA6C;AAC7C,sCAAsC;AACtC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA,oCAAoC;AACpC,2CAA2C;;AAE3C,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EAEnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EAGE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EAGE,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA,wCAAwC;;AAExC,sCAAsC;AACtC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,wEAAwE;EACxE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wEAAwE;EACxE,SAAS;EACT,MAAM;AACR;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;EAGE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAO;AACT;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;AACA,oCAAoC;;AAEpC,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA,gCAAgC;;AAEhC,sCAAsC;AACtC;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,iFAAiF;EACjF,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,aAAa;AACf;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,yBAAyB,EAAE,gEAAgE;AAC7F;AACA;EACE,oBAAoB;AACtB;AACA,mDAAmD;AACnD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,yEAAyE;EACzE,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;EACxB,+BAA+B;EAC/B,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,SAAO;EACP,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;EACV,SAAS;AACX;AACA,oCAAoC;;AAEpC,4CAA4C;AAC5C,sBAAsB;AACtB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA,oBAAoB;;AAEpB;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oBAAoB;AACpB;;;;EAIE,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;EAKE,oCAAoC;EACpC,oCAAoC;EACpC,oBAAoB;AACtB;AACA;;;;EAIE,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;EAIE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,SAAS;EACT,QAAQ;EACR,yCAAyC;EACzC,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;AACA,kBAAkB;;AAElB,iBAAiB;AACjB;;EAEE,yBAAyB;AAC3B;AACA;;;;EAIE,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,+BAA+B;EAC/B,iCAAiC;EACjC,wBAAwB;EACxB,cAAc;EACd,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EAEE,oCAAoC;EACpC,wBAAwB;EACxB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EAGE,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;;GAGG;AACH;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;AACA,eAAe;;AAEf;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,mCAAmC;IACnC,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,oCAAoC;IACpC,UAAU;IACV,SAAS;IACT,UAAU;EACZ;EACA;IACE,oCAAoC;IACpC,UAAU;IACV,SAAS;IACT,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,mCAAmC;EACrC;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,sCAAsC;IACtC,kBAAkB;EACpB;AACF;AACA,0CAA0C","sourcesContent":["/* common - start */\na.disabled-link {\n  pointer-events: none;\n  opacity: 0.5;\n}\nsection h1,\n.section-title h1,\n.section-title h2 {\n  font-family: \"AvertaSemiBold\", sans-serif;\n  font-size: 20px;\n  color: var(--colorYellow);\n}\nsection.full-ht {\n  min-height: calc(100vh - 180px);\n}\nsection.bg {\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-size: cover;\n  padding: 50px;\n}\nsection.bg .section-title h3 {\n  font-family: \"SegoePro-Bold\", sans-serif;\n  font-size: 40px;\n  text-transform: capitalize;\n  color: #f4f3f2;\n}\nsection.bg .section-title p {\n  font-size: 18px;\n}\nsection.bg .section-title + .bottom-text {\n  margin-top: 0;\n  color: var(--colorYellow);\n  height: 0;\n  opacity: 0;\n  transition: height 1s, margin-top 1s, opacity 0s;\n}\nsection.bg:hover .section-title + .bottom-text {\n  margin-top: 35vh;\n  height: auto;\n  opacity: 1;\n  transition: height 1s, margin-top 1s, opacity 1s;\n}\nsection.bg .section-title + .bottom-text p {\n  font-size: 22px;\n}\n\nbutton.back {\n  color: var(--colorYellow);\n}\n.breadcrumbs {\n  margin-top: -20px;\n}\n.breadcrumbs ul {\n  padding-left: 0;\n}\n.breadcrumbs ul li,\n.breadcrumbs ul li a {\n  display: inline-block;\n  vertical-align: middle;\n  color: var(--colorYellow);\n  font-size: 12px;\n}\n.breadcrumbs ul li:not(:last-child) {\n  margin-right: 5px;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  transition: background-color 5000s ease-in-out 0s;\n  -webkit-text-fill-color: #f2f2f2 !important;\n}\n\n::-webkit-input-placeholder {\n  /* Edge */\n  color: #999999 !important;\n}\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #999999 !important;\n}\n::placeholder {\n  color: #999999 !important;\n}\n\ntable tbody tr.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n@media (min-width: 576px) {\n  .modal-medium .modal-dialog {\n    max-width: 700px;\n  }\n}\n\n.long-desc {\n  max-height: 80px;\n  position: relative;\n  overflow-y: auto;\n}\n/* common - end */\n\n/* ======= Home SaaS - start ======= */\n.home-saas .inner {\n  background-color: #191e27;\n  padding: 20px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.home-saas .inner h4 {\n  color: #979a9f;\n  font-family: \"SegoePro-SemiBold\", sans-serif;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n.home-saas .inner .image {\n  margin-top: auto;\n  display: block;\n  text-align: center;\n}\n\n.saas-manage {\n  padding: 30px;\n  background-color: #191e27;\n  margin-top: 25px;\n}\n.saas-manage > .row {\n  align-items: center;\n}\n.saas-manage > .row > div {\n  text-align: center;\n  position: relative;\n}\n.saas-manage span {\n  display: block;\n}\n.saas-manage span.text {\n  color: var(--colorYellow);\n  margin-top: 10px;\n}\n.saas-manage .create {\n  position: relative;\n  display: inline-block;\n}\n.saas-manage .create button {\n  min-height: 90px;\n  height: 100%;\n  padding: 10px 35px;\n  background-color: #0c1017;\n}\n.saas-manage .popup-list {\n  display: none;\n  padding: 15px 20px;\n  background-color: #0c1017;\n  width: max-content;\n  position: absolute;\n  z-index: 1;\n  left: 50%;\n}\n.saas-manage .popup-list.show {\n  display: block;\n}\n.saas-manage .popup-list ul {\n  list-style: none outside;\n  padding-left: 0;\n  margin-bottom: 0;\n  text-align: left;\n}\n.saas-manage .popup-list ul li a {\n  color: #979a9f;\n  position: relative;\n}\n.saas-manage .popup-list ul li a.in-progress:before,\n.saas-manage .popup-list ul li a.completed:before {\n  content: \"\";\n  position: absolute;\n  left: -10px;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.saas-manage .popup-list ul li a.in-progress:before {\n  background-color: var(--colorYellow);\n}\n.saas-manage .popup-list ul li a.completed:before {\n  background-color: #08d155;\n}\n.saas-manage .popup-list ul li:not(:last-child) {\n  margin-bottom: 5px;\n}\n.saas-manage .create .popup-list {\n  left: auto;\n  right: calc(-100% - 20px);\n  top: 0;\n}\n\n.list-table {\n  position: relative;\n  margin-top: 25px;\n}\n.list-table h4 {\n  font-size: 16px;\n  color: var(--colorYellow);\n  padding-left: 30px;\n  position: absolute;\n  left: 0;\n  top: 17px;\n}\n.list-table div[data-test=\"datatable-entries\"] .bs-select {\n  display: none;\n}\n.list-table div[data-test=\"datatable-search\"] .form-control {\n  background-color: #191e27;\n  border: none;\n  padding: 10px 30px;\n  border-radius: 0;\n  width: 300px;\n  margin-bottom: 10px !important;\n}\n.list-table div[data-test=\"datatable-search\"]:before {\n  content: \"Search\";\n  color: var(--colorYellow);\n  margin-right: 10px;\n}\ntable.table-striped {\n  background-color: #191e27;\n}\n.table.table-striped > :not(caption) > * > *,\n.table.table-bordered > :not(caption) > * > *,\n.table > :not(caption) > * > * {\n  background-color: transparent;\n  color: #999999;\n}\ntable.table-striped > tbody > tr > *,\ntable.table-striped > tbody > tr:nth-of-type(odd) > * {\n  color: #85898e;\n}\ntable.table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #252a31;\n}\ntable.table-striped > tbody > tr > td {\n  padding-left: 30px;\n  padding-right: 30px;\n  height: 29px;\n}\ntable.table-striped > tbody > tr > td a {\n  color: inherit;\n}\ntable.table-striped > tbody > tr > td span.new {\n  background-color: var(--colorYellow);\n  font-family: \"SegoePro-SemiBold\", sans-serif;\n  font-size: 0.6em;\n  color: #3d4045;\n  padding: 0 3px;\n  border-radius: 5px;\n  margin-left: 10px;\n}\ntable.table-striped > thead[data-test=\"datatable-head\"] th {\n  color: var(--colorYellow);\n  font-weight: normal;\n  padding: 10px 30px;\n}\ntable.table-striped > thead[data-test=\"table-foot\"] {\n  display: none;\n}\n.list-table .dataTables_info {\n  display: none;\n}\n.list-table div[data-test=\"datatable-pagination\"] {\n  width: auto;\n  margin-left: auto;\n}\n.list-table .pagination .page-item .page-link {\n  min-width: 36px;\n  text-align: center;\n  cursor: pointer;\n}\n.list-table .pagination .page-item.disabled .page-link {\n  cursor: auto;\n}\n.list-table .pagination .page-item .page-link,\n.list-table .pagination .page-item:last-child .page-link,\n.list-table .pagination .page-item.disabled .page-link {\n  background-color: transparent;\n  border: none;\n  border-top: 0.25px solid #616369;\n  border-bottom: 0.25px solid #616369;\n  border-radius: 0;\n  color: #616369;\n}\n.list-table .pagination .page-item:first-child .page-link,\n.list-table .pagination .page-item:last-child .page-link {\n  border: 0.25px solid #616369;\n}\n.list-table .pagination .page-item:first-child .page-link:before {\n  content: \"\\2039\";\n  font-size: 30px;\n  line-height: 15px;\n  display: inline-block;\n  vertical-align: top;\n}\n.list-table .pagination .page-item:first-child .page-link span,\n.list-table .pagination .page-item:last-child .page-link span,\n.list-table .pagination .page-item .page-link span.sr-only {\n  display: none;\n}\n.list-table .pagination .page-item:last-child .page-link:before {\n  content: \"\\203A\";\n  font-size: 30px;\n  line-height: 15px;\n  display: inline-block;\n  vertical-align: top;\n}\n.list-table .pagination .page-item.active .page-link {\n  color: #85898e;\n}\n\ntable.table-bordered,\ntable.table-bordered > :not(:first-child) {\n  border-color: #3d4045;\n  border-width: 1px;\n  color: var(--colorGray);\n}\ntable.table-bordered thead th {\n  color: var(--colorYellow);\n  font-weight: normal;\n}\ntable.table-bordered tbody td {\n  vertical-align: middle;\n}\n/* ======= Home SaaS - end ======= */\n\n/* ======= Forms - start ======= */\nsection.form {\n  padding: 35px 40px;\n  background: #191e27 url(\"./../images/icons/form-bg.png\") no-repeat right\n    bottom -70px;\n}\n.formitem {\n  position: relative;\n}\n.formitem .form-label {\n  position: absolute;\n  transition-duration: 1s;\n}\ninput[type=\"text\"],\ninput[type=\"text\"]:focus,\ninput[type=\"email\"],\ninput[type=\"email\"]:focus,\ninput[type=\"password\"],\ninput[type=\"password\"]:focus {\n  border-width: 0 0 1px 0;\n  color: #f2f2f2;\n  border-color: #3d4045;\n  background: none;\n}\nlabel {\n  min-width: 70px;\n}\nlabel + input[type=\"text\"],\nlabel + input[type=\"text\"]:focus,\nlabel + input[type=\"email\"],\nlabel + input[type=\"email\"]:focus,\nlabel + input[type=\"password\"],\nlabel + input[type=\"password\"]:focus {\n  border-width: 1px;\n  display: inline-block;\n  vertical-align: middle;\n  width: calc(100% - 75px);\n  max-width: 250px;\n}\ninput[type=\"text\"]:read-only,\ninput[type=\"email\"]:read-only,\ninput[type=\"password\"]:read-only {\n  opacity: 0.25;\n}\nselect.form-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='gray' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n  background-repeat: no-repeat;\n  background-position-x: 100%;\n  background-position-y: 5px;\n  border: none;\n  border-bottom: 1px solid #3d4045;\n  border-radius: 0;\n  color: #979a9f;\n}\nselect.form-select.border {\n  border-color: #3d4045 !important;\n}\nselect.form-select option {\n  background-color: #0c1017;\n}\nform h4 {\n  font-size: 0.9rem;\n  color: var(--colorYellow);\n}\nform h4 + .repeat-address {\n  margin-left: 20px;\n}\nform h4 + .repeat-address label {\n  font-size: 13px;\n}\nform h5 {\n  font-size: 1rem;\n  color: var(--colorYellow);\n}\nform h6 {\n  font-size: 1em;\n  color: var(--colorYellow);\n}\nform fieldset {\n  border: 1px solid #3d4045;\n  padding: 20px 30px;\n}\nform fieldset.heading {\n  padding: 0 30px;\n  background-color: #161b22;\n}\nform fieldset.heading .fieldset-heading > h6,\nform fieldset.heading .fieldset-heading ~ div > h6 {\n  padding: 15px 0 10px;\n}\nform fieldset.heading .fieldset-heading ~ div > div {\n  padding: 10px 0;\n}\nform fieldset.heading .fieldset-heading ~ div > div h6 {\n  margin-top: 5px;\n}\nform fieldset .fieldset-heading,\nform fieldset .fieldset-heading ~ div:not(:last-child) {\n  position: relative;\n}\nform fieldset .fieldset-heading,\nform fieldset .fieldset-heading ~ div:not(:last-child) {\n  border-right: 1px solid #3d4045; /* min-width: fit-content; */\n}\nform fieldset .row.bdr-btm:not(:last-child) {\n  border-bottom: 1px solid #3d4045;\n}\nform fieldset .fieldset-heading > div,\nform fieldset .fieldset-heading ~ div:not(:last-child) > div {\n  position: relative;\n  z-index: 1;\n}\nform fieldset .fieldset-heading h5 {\n  width: 90%;\n  display: inline-flex;\n  align-items: center;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\nform fieldset .fieldset-heading h5 label {\n  line-height: 1em;\n  vertical-align: middle;\n}\nform fieldset .fieldset-heading ~ div:not(:last-child) > div {\n  /* width: 90%; */\n  position: relative;\n  z-index: 1;\n}\n/* form fieldset .fieldset-heading:after, form fieldset .fieldset-heading ~ div:not(:last-child):after { content: \"\"; position: absolute; left: 0; top: 0; width: 90%; height: 100%; border-right: 1px solid #3D4045; z-index: 0;} */\n.form-check-input[type=\"checkbox\"],\n.form-check-input[type=\"radio\"] {\n  background-color: transparent;\n  border-color: #979a9f;\n}\nform .form-select,\nform .form-control,\nform .form-select:focus,\nform .form-control:focus {\n  font-size: 14px;\n  background-color: transparent;\n  color: #ffffff;\n}\nform .form-select:focus-visible,\nform .form-control:focus-visible {\n  outline: none;\n}\nform fieldset:disabled,\nbutton:disabled {\n  opacity: 0.6;\n}\nform .form-select:disabled {\n  background-color: transparent;\n}\nform .message {\n  color: #ff0000;\n}\n.form-check-inline .form-check-label {\n  min-width: auto;\n}\n\n.roles-wrap,\n.profile-wrap {\n  display: inline-block;\n  width: calc(100% - 75px);\n  max-width: 250px;\n  vertical-align: top;\n  margin-left: 5px;\n}\n.profile-wrap {\n  position: relative;\n}\n.profile-wrap input[type=\"text\"] {\n  border-width: 1px;\n  padding-right: 30px;\n}\n.profile-wrap button.btn-transparent {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  border-radius: 3px;\n  width: 23px;\n  height: 23px;\n  padding: 0;\n  line-height: 21px;\n}\n.profile-wrap.full-width {\n  width: 100%;\n  max-width: none;\n  margin-left: 0;\n}\n.profile-wrap.full-width input[type=\"text\"] {\n  border-width: 0 0 1px 0;\n}\n.roles-wrap select {\n  border: 1px solid #3d4045;\n  border-radius: 6px;\n}\n\nsection.form.no-bg-img {\n  background-image: none;\n}\n\nul.machine-list {\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none outside;\n}\nul.machine-list li {\n  display: inline-block;\n  margin-right: 20px;\n  border: 1px solid var(--colorYellow);\n  border-radius: 5px;\n  font-size: 12px;\n  padding: 3px 10px;\n  min-width: 120px;\n  display: inline-flex;\n  justify-content: space-between;\n}\nul.machine-list li button.btn-close {\n  background-size: 10px auto;\n}\n\n.modules-preview h2 {\n  font-family: \"AvertaSemiBold\", sans-serif;\n  font-size: 20px;\n  color: var(--colorYellow);\n}\nul.tick {\n  list-style: none outside;\n  padding-left: 0;\n}\nul.tick > li {\n  color: var(--colorYellow);\n}\nul.tick > li > div.tick-icon {\n  display: flex;\n  align-items: center;\n}\nul.tick > li > div.tick-icon:before {\n  content: \"\\2713\";\n  color: var(--colorOrange);\n  margin-right: 10px;\n}\nul.tick > li > ul {\n  list-style: none outside;\n  padding-left: 0;\n  font-size: 12px;\n  color: var(--colorGray);\n  margin-top: 20px;\n}\nul.tick.row li.border-end:last-child {\n  border-right: none !important;\n}\n/* ======= Forms - end ======= */\n\n/* ======= View Client - start ======= */\n.client-status {\n  background-color: #191e27;\n  padding: 30px 40px;\n  margin-top: 25px;\n}\n.client-status h2 {\n  font-size: 14px;\n  color: var(--colorYellow);\n  margin-bottom: 20px;\n}\n.progressbar {\n  list-style: none outside;\n  margin-bottom: 0;\n  padding-left: 0;\n  display: flex;\n}\n.progressbar li {\n  position: relative;\n  text-align: center;\n  width: 20%;\n}\n.progressbar li:before {\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background-color: #3d4045;\n  margin: 0 auto 10px auto;\n  outline: 1px solid #3d4045;\n  outline-offset: 3px;\n  display: block;\n  border-radius: 50%;\n  text-align: center;\n}\n.progressbar li.completed:before {\n  content: \"\\2713 \";\n  color: var(--colorYellow);\n  outline-color: var(--colorYellow);\n}\n.progressbar li:after {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - 30px);\n  height: 1px;\n  border-top: 1px dashed #3d4045;\n  top: 10px;\n  left: calc(-50% + 16px);\n  z-index: 0;\n}\n.progressbar li:first-child:after {\n  content: none;\n}\n.progressbar li,\n.progressbar li a {\n  color: var(--colorGray);\n}\n\n.client-subscription {\n  background-color: #191e27;\n  padding: 25px 40px;\n  margin-top: 25px;\n  margin-bottom: 25px;\n  color: #979a9f;\n}\n.client-subscription h2 {\n  font-size: 14px;\n  color: var(--colorYellow);\n  margin-bottom: 20px;\n}\n.client-subscription .client-infrastructure {\n  background-color: #0c0f14;\n  padding: 15px 40px;\n  text-align: center;\n}\n.client-subscription .client-infrastructure span {\n  display: block;\n}\n.client-subscription .client-infrastructure span.text {\n  line-height: 1;\n  margin-top: 5px;\n}\n.client-subscription .subscription {\n  list-style: none outside;\n  margin-bottom: 0;\n  padding-left: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  text-align: center;\n}\n.client-subscription .subscription li {\n  padding: 10px 15px;\n  border: 1px solid #3d4045;\n  margin: 5px 7px; /* width: 150px; */\n  position: relative;\n}\n.client-subscription.saas-subscription .subscription li {\n  width: 150px;\n}\n.client-subscription .subscription li span {\n  display: block;\n}\n.client-subscription .subscription li span.image {\n  min-height: 40px;\n}\n.client-subscription .subscription li span.text {\n  margin-top: 5px;\n  font-size: 13px;\n}\n.client-subscription .subscription li > button.subscribe {\n  display: none;\n  position: absolute;\n  top: 10px;\n  color: white;\n  font-size: 10px;\n  width: 55px;\n  left: 50%;\n  margin-left: -27px;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 10px 5px;\n}\n.client-subscription .subscription li:hover > button.subscribe {\n  display: block;\n}\n.client-subscription .subscription li.subscribed:before {\n  content: \"\\2713 \";\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 15px;\n  position: absolute;\n  right: -7px;\n  top: -7px;\n  color: #3d4045;\n  width: 15px;\n  height: 15px;\n  background-color: var(--colorYellow);\n  display: block;\n  border-radius: 50%;\n  text-align: center;\n}\n.client-subscription .subscription li.subscribed span.image img {\n  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)\n    hue-rotate(347deg) brightness(96%) contrast(107%);\n}\n.client-subscription .subscription li.subscribed span.text {\n  color: var(--colorYellow);\n}\n\n.client-subscription .react-multi-carousel-list.subscription li {\n  border: none;\n  text-align: center;\n  margin: 0;\n}\n.client-subscription .react-multi-carousel-list.subscription li > div {\n  width: 100%;\n  border: 1px solid #3d4045;\n  display: inline-block;\n}\n\n.label-wrap > label {\n  position: relative;\n  display: block;\n  padding: 10px;\n  text-align: center;\n}\n/* Match .reports-list .item > div's box so function chips are the same\n   size as product cards, whether or not that function has a matching icon.\n   react-multi-carousel wraps every item in its own <li>, so the legacy\n   \".subscription li > div\" border rule below still matches this div even\n   though it was written for the old markup -- override it back to none,\n   same as product cards (.reports-list has no such border at all). */\n\n.label-wrap span.image {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  height: 85px !important;\n  min-height: 85px !important;\n  max-width: 100%;\n  margin-bottom: 10px;\n  background-color: #191e27;\n}\n.label-wrap span.image img {\n  width: 50px !important;\n  height: 50px !important;\n  object-fit: contain;  margin: 0 auto;\n}\n.label-wrap input[type=\"radio\"] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n/* .label-wrap input[type=\"radio\"]:checked + span.image img {filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%) hue-rotate(347deg) brightness(96%) contrast(107%);} */\n.label-wrap input[type=\"radio\"]:checked + span.image + span.text {\n  color: var(--colorYellow);\n}\n\n.react-multiple-carousel__arrow--left {\n  left: 0;\n}\n.react-multiple-carousel__arrow--right {\n  right: 0;\n}\n/* ======= View Client - end ======= */\n\n/* ======= Client Interface - start ======= */\n/* ======= Home SaaS - start ======= */\n.workbasket {\n  background-color: #191e27;\n  padding: 20px 40px;\n  margin-top: 25px;\n}\n.workbasket h2 {\n  font-size: 14px;\n  color: var(--colorGray);\n  margin-bottom: 20px;\n}\n.workbasket ul {\n  list-style: none outside;\n  margin-bottom: 0;\n  padding-left: 0;\n  display: flex;\n}\n.workbasket ul li:not(:last-child) {\n  margin-right: 20px;\n}\n.workbasket ul li a {\n  color: var(--colorYellow);\n  text-decoration: underline;\n}\n/* ======= Home SaaS - end ======= */\n/* ======= Client Interface - end ======= */\n\n/* ======= Map meta data - start ======= */\nfieldset.starred {\n  position: relative;\n  overflow: hidden;\n}\nfieldset.starred:before {\n  position: absolute;\n  display: block;\n  content: \"\";\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 0;\n  border-top: 40px solid #3d4045;\n  border-right: 40px solid transparent;\n}\nfieldset.starred:after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  top: 4px;\n  left: 4px;\n  width: 16px;\n  height: 16px;\n  background: url(\"./../images/icons/star-icon.png\");\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  min-width: auto;\n  height: 20px;\n  margin: 0 10px;\n}\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #2c2d2f;\n  border: 1px solid var(--colorGray);\n  border-radius: 20px;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 1px;\n  bottom: 1px;\n  background-color: var(--colorGray);\n  border-radius: 50%;\n  transition: 0.4s;\n}\ninput:checked + .slider {\n  border: 1px solid var(--colorYellow);\n}\ninput:checked + .slider:before {\n  -webkit-transform: translateX(20px);\n  -ms-transform: translateX(20px);\n  transform: translateX(20px);\n  background-color: var(--colorYellow);\n}\ntd .switch {\n  width: 30px;\n  height: 15px;\n}\ntd .slider:before {\n  width: 11px;\n  height: 11px;\n}\ntd input:checked + .slider:before {\n  -webkit-transform: translateX(15px);\n  -ms-transform: translateX(15px);\n  transform: translateX(15px);\n}\ntd input:disabled + .slider {\n  opacity: 0.5;\n}\n/* ======= Map meta data - end ======= */\n\n/* ======= Deploy BI - start ======= */\n.deploy-bi .col-wrap {\n  background-color: #0f1622;\n  padding: 10px 15px;\n  display: flex;\n  border-radius: 10px;\n  height: 100%;\n}\n.deploy-bi .col-wrap.cursor-pointer {\n  cursor: pointer;\n}\n.deploy-bi .icon {\n  min-width: 90px;\n  height: 90px;\n  background-color: #191e27;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 30px;\n}\n.deploy-bi .icon img {\n  max-width: 50px;\n}\n.deploy-bi .content-wrap {\n  /* margin-top: 20px; */\n  color: var(--colorYellow);\n}\n.deploy-bi .content-wrap h6 {\n  font-family: \"SegoePro-SemiBold\", sans-serif;\n}\n.deploy-bi .content-wrap span,\n.deploy-bi .content-wrap .info {\n  font-size: 12px;\n  vertical-align: middle;\n  display: inline-block;\n}\n.deploy-bi .content-wrap .info {\n  border: 1px solid var(--colorYellow);\n  border-radius: 50%;\n  width: 15px;\n  height: 15px;\n  line-height: 15px;\n  text-align: center;\n  font-size: 10px;\n  margin-left: 7px;\n  color: var(--colorYellow);\n}\n.deploy-bi .button-wrap {\n  min-width: 100px;\n}\n.ribbon {\n  display: inline-block;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 8px), 0 100%);\n  background-color: var(--colorYellow);\n  width: 20px;\n  height: 48px;\n  margin-top: -10px;\n  position: relative;\n}\n.Subscribe > div.cursor-pointer {\n  cursor: pointer;\n}\n.Subscribe .status {\n  opacity: 0.53;\n}\n.Subscribe .ribbon {\n  opacity: 0.37;\n}\n.Subscribe .ribbon:before {\n  background-color: #0f1622;\n  position: absolute;\n  display: block;\n  content: \"\";\n  width: 18px;\n  height: 46px;\n  clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 8px), 0 100%);\n  left: 1px;\n  top: 0;\n}\n.Subscribe .button-wrap button.btn-yellow {\n  background-color: transparent;\n  color: var(--colorYellow);\n}\n.Unavailable img,\n.Unavailable h6,\n.Unavailable .status {\n  opacity: 0.34;\n}\n.Unavailable .status {\n  color: #ffffff;\n}\n.Unavailable .status .info {\n  border-color: #ffffff;\n}\n.Unavailable .ribbon {\n  background-color: #2c2c2c;\n  opacity: 0.4;\n}\n.button-wrap {\n  margin-left: auto;\n  text-align: center;\n}\n.button-wrap button.btn-yellow {\n  padding: 0 5px;\n  border-radius: 5px;\n  margin-top: 20px;\n}\n\n.modal-deploy-bi .modal-dialog {\n  max-width: 840px;\n}\n.modal-deploy-bi .modal-content {\n  background-color: #0c1017;\n}\n.modal-deploy-bi .modal-header {\n  border-bottom: 1px solid #212121;\n  align-items: flex-start;\n}\n.modal-deploy-bi .modal-header > div {\n  text-align: center;\n  flex: 1;\n}\n.modal-deploy-bi .modal-footer {\n  border-top: 1px solid #212121;\n  justify-content: flex-end;\n}\n.modal-deploy-bi button.btn-close {\n  width: 5px;\n  height: 5px;\n  top: -15px;\n  right: -15px;\n}\n.modal-deploy-bi .col-wrap {\n  background-color: transparent;\n  padding: 0;\n  text-align: left;\n}\n.modal-deploy-bi .button-wrap {\n  margin-left: 30px;\n  min-width: auto;\n}\n.modal-deploy-bi .ribbon {\n  margin-top: 15px;\n}\n.modal-deploy-bi .steps {\n  list-style: none outside;\n  padding: 0;\n  display: inline-flex;\n  justify-content: center;\n  position: relative;\n  color: var(--colorYellow);\n  margin-left: auto;\n  margin-right: auto;\n}\n.modal-deploy-bi .steps:before {\n  display: block;\n  content: \"\";\n  height: 1px;\n  width: 75%;\n  background-color: #212121;\n  position: absolute;\n  top: 7px;\n}\n.modal-deploy-bi .steps li {\n  padding: 0 30px;\n  text-align: center;\n}\n.modal-deploy-bi .steps li span {\n  width: 15px;\n  height: 15px;\n  display: inline-block;\n  border: 1px solid var(--colorYellow);\n  border-radius: 50%;\n  position: relative;\n  background-color: #0c1017;\n}\n.modal-deploy-bi .steps li.completed span:after {\n  width: 7px;\n  height: 7px;\n  display: block;\n  content: \"\";\n  background-color: var(--colorYellow);\n  border-radius: 50%;\n  position: absolute;\n  left: 3px;\n  top: 3px;\n}\n.modal-deploy-bi .table {\n  color: #f4f3f2;\n  font-size: 12px;\n}\n.modal-deploy-bi .border-bottom {\n  border-color: #212121 !important;\n}\n\n.modal.terms-policies .modal-body {\n  max-height: 50vh;\n  overflow-y: auto;\n}\n.modal.terms-policies .modal-body h4 {\n  color: inherit;\n  font-family: \"SegoePro-Bold\", sans-serif;\n  font-size: inherit;\n}\n.modal .modal-body a {\n  color: inherit;\n}\n.modal-footer button,\n.modal-footer button:active,\n.modal-footer button:focus {\n  background-color: #fd9f29;\n  color: #0c1017;\n  font-weight: bold;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.modal-footer button:active:hover,\n.modal-footer button:hover {\n  background-color: #fd9f29;\n  color: #0c1017;\n  opacity: 0.8;\n}\n/* ======= Deploy BI - end ======= */\n\n/* ======= Users - start ======= */\n.toggle-password {\n  position: absolute;\n  right: 0;\n  top: 10px;\n  cursor: pointer;\n}\n.datatable.datatable-users tbody[data-test=\"table-body\"] td div {\n  display: flex;\n  align-items: flex-start;\n}\n.datatable.datatable-users tbody[data-test=\"table-body\"] td div ul {\n  list-style: disc inside;\n}\n.datatable.datatable-users tbody[data-test=\"table-body\"] td div ul li {\n  margin-bottom: 0;\n}\n.datatable.datatable-users\n  tbody[data-test=\"table-body\"]\n  td\n  div\n  ul\n  li:last-child {\n  margin-bottom: 0;\n}\n.datatable.datatable-users .fas,\n.datatable.datatable-users .far {\n  color: #85898e;\n}\n/* ======= Users - end ======= */\n\n/* ======= Dashboard - start ======= */\nsection.iframe-wrapper {\n  height: 60vh;\n}\nsection.iframe-wrapper > iframe {\n  height: 100%;\n  width: 100%;\n}\nsection.bg-dark-gray {\n  background-color: #191e27;\n  margin-top: 25px;\n  padding: 40px;\n  margin-bottom: 25px;\n  color: var(--colorYellow);\n}\n.reports-list {\n  /* flex-wrap: nowrap; overflow-x: auto; padding-top: 25px; padding-bottom: 25px;*/\n  text-align: center;\n}\n.reports-list li {\n  padding: 10px 15px;\n}\n.reports-list .unavailable .item {\n  opacity: 0.6;\n}\n.reports-list .item {\n  display: inline-block;\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n}\n.reports-list .item.disabled {\n  pointer-events: none;\n}\n.reports-list .item > img {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  font-size: 20px;\n  display: none;\n}\n.reports-list .item:hover > img,\n.reports-list .item.active > img,\n.reports-list .item.disabled > img {\n  display: block;\n}\n.reports-list .item > div {\n  margin-bottom: 10px;\n  height: 85px;\n  max-width: 100%;\n  background-color: #121212;\n  line-height: 85px;\n}\n.reports-list .item span {\n  display: block;\n}\n.reports-list .item > button {\n  display: none;\n  position: absolute;\n  top: 28px;\n  color: white;\n  font-size: 10px;\n  width: 55px;\n  left: 50%;\n  margin-left: -27px;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 10px 5px;\n}\n.reports-list .item > button.txt-yellow {\n  color: var(--colorYellow);\n}\n.reports-list .item > button.txt-gray {\n  color: var(--colorGray);\n}\n.reports-list .item:hover > button {\n  display: block;\n}\n.content-wrap {\n  flex-wrap: nowrap;\n}\n.content-wrap main {\n  flex: 1;\n  min-width: 0;\n}\n.content-wrap aside {\n  width: var(--rightNavWidth);\n  max-width: var(--rightNavWidth);\n  flex-shrink: 0;\n  height: auto;\n  overflow: visible;\n  padding-right: 0;\n  box-sizing: border-box;\n}\n\n/* rightnav variable and collapsed support */\n:root {\n  --rightNavWidth: 28%;\n  --sidebarTopOffset: 138px; /* pages can override this to account for header/steps heights */\n}\nbody.rightnav-collapsed {\n  --rightNavWidth: 0px;\n}\n/* when collapsed reduce inner content visibility */\n.right-aside {\n  position: fixed !important;\n  top: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  z-index: 1001;\n  transition: width 0.2s ease, height 0.2s ease, background-color 0.2s ease;\n  overflow: hidden;\n  width: var(--rightNavWidth);\n  max-width: var(--rightNavWidth);\n  height: 100vh !important;\n  background-color: var(--color2);\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.3);\n}\n.right-aside-inner {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  overflow-x: hidden !important;\n  position: relative;\n}\n.right-aside-inner iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  overflow: hidden;\n}\n\n/* collapsed state: only show the toggle button */\nbody.rightnav-collapsed .right-aside .right-aside-inner {\n  display: none;\n}\nbody.rightnav-collapsed .right-aside {\n  width: 0 !important;\n  max-width: 0 !important;\n  border-left: none !important;\n  box-shadow: none !important;\n  overflow: hidden !important;\n}\n\n#chat-body {\n  height: calc(100% - 120px);\n  margin-bottom: 20px;\n  overflow-y: auto;\n  background-color: #191e27;\n  border-radius: 5px;\n}\n#chat-body .chat-list {\n  list-style: none outside;\n  padding-left: 0;\n}\n.chat-list .msg-wrapper > div {\n  display: flex;\n  padding: 10px;\n  align-items: center;\n}\n.chat-list .msg-wrapper.bot-msg > div {\n  background-color: var(--colorYellow);\n  color: #000000;\n}\n.chat-list li.msg-wrapper > div .text {\n  margin-left: 10px;\n  flex: 1;\n  white-space: pre-line;\n}\n#form-chat .form-wrapper {\n  position: relative;\n}\n#form-chat .form-wrapper textarea {\n  border-color: #3d4045;\n  padding-right: 35px;\n}\n#form-chat .form-wrapper button[type=\"submit\"] {\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  padding: 0;\n  border: 0;\n}\n/* ======= Dashboard - end ======= */\n\n/* ======= Loan Underwrite - start ======= */\n/* variables - start */\n:root {\n  --color1: #0c1017;\n  --color2: #191e27;\n  --color3: #979a9f;\n  --color4: #323232;\n}\n/* variables - end */\n\n.dark-bg {\n  background-color: var(--color2);\n}\n.alert-msg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: var(--colorYellow);\n  color: var(--color1);\n  text-align: center;\n  width: 100%;\n  padding: 10px 20px;\n  z-index: 9999;\n}\n\n/* buttons - start */\n.loan-underwrite button.btn,\n.loan-underwrite button.btn:hover,\n.loan-underwrite button.btn:focus,\n.loan-underwrite button.btn:first-child:active {\n  border-radius: 0;\n  font-family: \"SegoePro-Bold\", sans-serif;\n  font-size: 15px;\n  padding: 10px 25px;\n}\n.loan-underwrite button.btn-primary,\n.loan-underwrite button.btn-primary:hover,\n.loan-underwrite button.btn-primary:focus,\n.loan-underwrite button.btn-primary:first-child:active,\n.loan-underwrite button.btn-primary:disabled {\n  border: 1px solid var(--colorYellow);\n  background-color: var(--colorYellow);\n  color: var(--color1);\n}\n.loan-underwrite button.btn-transparent,\n.loan-underwrite button.btn-transparent:hover,\n.loan-underwrite button.btn-transparent:focus,\n.loan-underwrite button.btn-transparent:first-child:active {\n  border-color: var(--colorYellow);\n  background-color: #000000;\n  color: #fd9f29;\n}\n.loan-underwrite button.btn-plain,\n.loan-underwrite button.btn-plain:hover,\n.loan-underwrite button.btn-plain:focus,\n.loan-underwrite button.btn-plain:first-child:active {\n  border: none;\n}\n.loan-underwrite button.btn-plain {\n  color: #ffffff;\n}\n.loan-underwrite button.btn-plain:hover {\n  color: var(--colorYellow);\n}\n\n.loan-underwrite .btn-dotted-bg {\n  position: relative;\n}\n.loan-underwrite .btn-dotted-bg:before {\n  content: \"\";\n  display: block;\n  width: 80%;\n  left: 50%;\n  top: 50%;\n  border-top: 1px dashed var(--colorYellow);\n  position: absolute;\n  transform: translate(-50%, -50%);\n  z-index: -1;\n}\n/* buttons - end */\n\n/* form - start */\n.loan-underwrite .form-label,\n.loan-underwrite label {\n  color: var(--colorYellow);\n}\n.loan-underwrite .form-control,\n.loan-underwrite .form-control:focus,\n.loan-underwrite .form-select,\n.loan-underwrite .form-select:focus {\n  background-color: var(--color2);\n  border-color: var(--color2);\n  border-radius: 0;\n  color: var(--colorWhite);\n  width: 100%;\n  max-width: 100%;\n  display: block;\n}\n.loan-underwrite .form-check-input,\n.loan-underwrite .form-check-input:focus {\n  background-color: var(--color2);\n  /* border-color: var(--color2); */\n  color: var(--colorWhite);\n  display: block;\n  /* margin-bottom: 0.5rem; */\n}\n.loan-underwrite .form-control[type=\"number\"]::-webkit-inner-spin-button,\n.loan-underwrite input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n}\n.loan-underwrite .form-control[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n.loan-underwrite .input-group-text {\n  border-radius: 0;\n  background-color: var(--colorYellow);\n  color: var(--colorWhite);\n  border-color: var(--colorYellow);\n  border-radius: 0;\n  width: 50px;\n  font-size: 14px;\n}\n.loan-underwrite .input-group-text.read-only {\n  opacity: 0.25;\n}\n.loan-underwrite .bi {\n  position: relative;\n  bottom: 10px;\n  font-size: 10px;\n}\n.loan-calculate .switch {\n  width: 30px;\n  height: 15px;\n  margin-bottom: 0.5rem;\n}\n.loan-calculate .slider:before {\n  width: 11px;\n  height: 11px;\n}\n.loan-calculate input:checked + .slider:before {\n  -webkit-transform: translateX(15px);\n  -ms-transform: translateX(15px);\n  transform: translateX(15px);\n}\n.loan-calculate input:disabled + .slider {\n  opacity: 0.5;\n}\n.loan-calculate input:disabled {\n  opacity: 0.25;\n}\n.loan-calculate select:disabled {\n  opacity: 0.25;\n}\n.loan-calculate .col-sm-4 {\n  flex: 0 0 auto !important;\n  width: 33.333333% !important;\n}\n/* .loan-underwrite .divider {\n  display: flex;\n  align-items: center;\n} */\n.loan-underwrite .divider:before,\n.divider:after {\n  content: none;\n}\n\n#decision .row {\n  flex-wrap: nowrap;\n}\n\n#decision .col-sm-4 {\n  flex: 0 0 auto !important;\n  width: 33.333333% !important;\n}\n\n.loan-underwrite-header .steps {\n  list-style: none outside;\n  padding: 0;\n  display: flex;\n  justify-content: space-around;\n  position: relative;\n  color: var(--colorYellow);\n  margin-left: auto;\n  margin-right: auto;\n}\n.loan-underwrite-header .steps:before {\n  display: block;\n  content: \"\";\n  height: 1px;\n  width: 79%;\n  background-color: #212121;\n  position: absolute;\n  top: 7px;\n  left: 10%;\n}\n.loan-underwrite-header .steps li {\n  padding: 0 30px;\n  text-align: center;\n}\n.loan-underwrite-header .steps li span {\n  width: 15px;\n  height: 15px;\n  display: inline-block;\n  border: 1px solid var(--colorYellow);\n  border-radius: 50%;\n  position: relative;\n  background-color: #0c1017;\n}\n.loan-underwrite-header .steps li.completed span:after {\n  width: 7px;\n  height: 7px;\n  display: block;\n  content: \"\";\n  background-color: var(--colorYellow);\n  border-radius: 50%;\n  position: absolute;\n  left: 3px;\n  top: 3px;\n}\n\n.loan-underwrite .table th {\n  color: var(--color3);\n}\n.loan-underwrite .table thead th {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  text-align: right;\n}\n.loan-underwrite .table tbody td {\n  color: var(--colorYellow);\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.loan-underwrite .underwrite-loan .icon {\n  height: 55px;\n}\n/* form - end */\n\n@media (min-width: 640px) {\n  .loan-underwrite .container-wrapper {\n    padding-left: 50px;\n    padding-right: 50px;\n  }\n  .loan-underwrite-header .steps ul {\n    flex-direction: row;\n    justify-content: space-around;\n  }\n  .loan-underwrite-header .steps ul li {\n    flex-direction: column;\n  }\n  .loan-underwrite-header .steps ul li > span {\n    margin-top: 5px;\n  }\n  .loan-underwrite-header .steps ul li.completed > span:before {\n    content: \"\\2713\";\n    color: var(--colorGreen);\n    line-height: 12px;\n    border: 1px solid var(--colorGreen);\n    border-radius: 3px;\n    display: inline-block;\n    margin-right: 7px;\n    font-size: 9px;\n    width: 13px;\n    height: 13px;\n    text-align: center;\n    vertical-align: middle;\n  }\n  .loan-underwrite-header .steps ul:before {\n    border-top: 1px dashed var(--color3);\n    width: 35%;\n    top: 35px;\n    right: 50%;\n  }\n  .loan-underwrite-header .steps ul:after {\n    border-top: 1px dashed var(--color3);\n    width: 35%;\n    top: 35px;\n    left: 50%;\n  }\n\n  .loan-underwrite .table thead {\n    background-color: var(--color2);\n    border-top: 1px solid var(--color4);\n  }\n  .loan-underwrite .table thead th {\n    border-bottom: none;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    text-align: center;\n    vertical-align: top;\n  }\n  .loan-underwrite .table tbody td {\n    border-bottom: 1px solid var(--color4);\n    text-align: center;\n  }\n}\n/* ======= Loan Underwrite - end ======= */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
